import React from "react";
import HuaweiIcon from "../../assets/img/stm-huawei.png";
import AppStoreIcon from "../../assets/img/stm-app-store.png";
import PlayStoreIcon from '../../assets/img/stm-play-store.png';


const stf_download_links = (props) => {

    return (
        <div className={props.classes}>
            {props.google_play_link &&
                <a
                    href={props.google_play_link}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <img src={PlayStoreIcon} alt="Play Store" />
                </a>
            }
            {props.app_store_link &&
                <a
                    href={props.app_store_link}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <img src={AppStoreIcon} alt="App Store" />
                </a>
            }
            {props.app_store_link &&
                <a
                    href={props.huawei_store_link}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <img src={HuaweiIcon} alt="Huawei" />
                </a>
            }
            { props.children}
        </div >
    );
}

export default stf_download_links;